import ToursCardList from "./tours-card-list";
import ToursList from "./tours-list";
import ServiceLocator from "../../../../../domain/service-locator";
import Layout from "../../../../components/layout";
import AnimatedPageTransition from "../../../../../domain/module/navigation/animated-page-transition";

export const ToursPage = () => {
  const { applicationConfig } = ServiceLocator.MasterDataModule.masterData;
  return (
    <AnimatedPageTransition>
      <div className="overflow-y-scroll hidden-scrollbar w-full h-full">
        <Layout
          headerLeftComponents={["back"]}
          headerRightComponents={[]}
          backTransitionOption={{
            pageInType: "fade",
            pageOutType: "fade",
          }}
        >
          {applicationConfig?.toursPageLayoutType === "Card" ? (
            <ToursCardList />
          ) : (
            <ToursList />
          )}
        </Layout>
      </div>
    </AnimatedPageTransition>
  );
};

export default ToursPage;
